import { render } from "./Loading.vue?vue&type=template&id=8914e02a"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=8914e02a&lang=less"
script.render = render

export default script